import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { Loading,Message } from 'element-ui'
import goods from '../utils/goods'

import $ from 'jquery'
import {multiply} from '../utils/tool'
Vue.use(Vuex)

export default new Vuex.Store({
//配置
plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths:['goods_cart','goods_cart_count','goods_cart_total','goods_cart_drawer','buyNow']
   })],

  state: {
    
    goods_cart: [],
    goods_cart_count:0,
    goods_cart_total:0,
    goods_cart_drawer:false,
    goodsList: [],
    buyNow:[],
    //这里放全局参数
  },

  mutations: {
    //这里是set方法
    setGoods_cart(state,value) {
        state.goods_cart = value
        
    },
    setGoods_cart_count(state,value) {     
        state.goods_cart_count = value
    },
    setGoods_cart_drawer(state,value) {
        state.goods_cart_drawer = value
    },
    setGoods_cart_total(state,value){
        state.goods_cart_total = value
    },
    setGoods(state,value) {
        state.goodsList = value
    },
    setBuyNow(state,value){
        state.buyNow = value
    }
    
  },



  actions: {
    // 处理state的方法体
    // 购物车商品 数量修改
    updateItemCount({ state, commit } , { type, item, index }){
        console.log('context',state,type,item,index)
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
       new Promise((resolve,reject) => {
        setTimeout(() => {
            loadingInstance.close()
            resolve()
        }, 1500);
        
       
       }).then(()=>{
        let goodsCart = state.goods_cart
        goodsCart.map((v,idx)=>{
            if(index == idx){
                if(type == 'cut'){
                    v.count--
                    if(v.count == 0){
                        goodsCart.splice(index,1)
                    }            
                }
                if(type == 'add'){
                    v.count++
                }
                if(type == 'delete'){
                    goodsCart.splice(index,1)
                }
            }
            v.total = v.count * Number(v.amount)
            // sessionStorage.setItem('goods_cart',JSON.stringify(goodsCart))
            commit('setGoods_cart',goodsCart)
            let count = 0
            let total = 0
            state.goods_cart.map(v=>{
                count = Number(v.count) + count
                total = Number(v.total) + total
            })
            commit('setGoods_cart_count', count)
            commit('setGoods_cart_total',total.toFixed(2))
        })
    })
        
        
        
    },
    // 商品列表
    getGoods({commit},{name,size}){
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
       new Promise((resolve,reject) => {
        setTimeout(() => {
            loadingInstance.close()
            
            console.log('goods',goods.data,name)
            let result  = goods.data[name].map(v=>{   
                let images = []  
                let colors = []
                let sizes = []
                let id = v.product_listing_result_id
                let item = v.variant_displays.map(c=>{
                if(!c.in_stock){return}
                    let obj = {}
                    obj.color_name = c.color_name
                    obj.specific_color_name = c.specific_color_name
                    obj.color_hex = c.color_hex
                    if(colors.length>0 ){
                        let find_color = colors.findIndex(f=>{return f.specific_color_name == c.specific_color_name})
                        if(find_color<0){
                            colors.push(obj)
                        }
                        
                    }else if(colors.length == 0){
                        colors.push(obj)
                    }
                    if(sizes.length>0){
                        let find_size = sizes.findIndex(s=>{return s == c.size})
                      
                        if(find_size<0){
                            sizes.push(c.size)
                        }
                    
                    }else if(sizes.length == 0){
                        sizes.push(c.size)
                    }
                    
                    return c
                    
                })
                v.variant_displays[v.variant_index].image_urls.map(i=>{
                    if(i.endsWith('.jpg')|| i.endsWith('.png') || i.endsWith('.jpeg')){
                        images.push(i)
                    }
                })
                v.variant_displays[v.variant_index].description = v.des
                v = v.variant_displays[v.variant_index]
                v.amount = multiply(v.original_price)
                if(id == '552a4573-fd6f-43a4-a903-8fd9488f46c5'){
                    v.amount = '25.8'
                }
                if(id == '548ac16e-c8bd-43a0-b0cb-1e5edefc79be'){
                    v.amount = '25.5'
                }
                // v.amount = v.original_price
                // console.log('amount',v.amont,v.original_price,multiply(v.original_price))
              
                v.sizes = sizes
                v.colors = colors
                v.frontImage = images[0]
                v.backImage = images[1]
                v.name = v.title
             
                v.id = id

                return v
            })
            // console.log('result',result)
            resolve(result)
        }, 1500);
       }).then(res=>{
        commit('setGoods',res)
       })
     
     
 
    },
    addCart({state,commit},{item}){
        let options = {
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }
       let loadingInstance = Loading.service(options)
         new Promise((resolve, reject)=>{
             setTimeout(() => {
                loadingInstance.close()
                resolve()
            }, 1500);
        }).then(()=>{
       
            let goodsCart = state.goods_cart
            let product = item
            let color_name = product.color_name
            let size_name = product.size
            
            
            let is_find = goodsCart.findIndex((v, index) => {
                console.log('v.id',v.id)
                return v.id == product.id  && v.color_name == color_name && v.size == size_name
            })
            console.log('goodsCart',product.id,goodsCart,is_find)
            if(is_find > -1){
                let count = Number( goodsCart[is_find].count) + 1
                let amount = Number(goodsCart[is_find].amount)
                let total = (count * amount).toFixed(2)
                goodsCart[is_find].total = total
                goodsCart[is_find].count = count
                
                commit('setGoods_cart',goodsCart)
                commit('setGoods_cart_drawer',true)

            }else{
                let count = 1
                let amount = Number(product.amount)
                let total = (count * amount).toFixed(2)
                product.color_name = color_name
                product.size_name = size_name
                product.total = total
                product.count = count
                goodsCart.push(product)
                commit('setGoods_cart',goodsCart)
                commit('setGoods_cart_drawer',true)
            }
            let count = 0
            let total = 0
            state.goods_cart.map(v=>{
                count = Number(v.count) + count
                total = Number(v.total) + total
            })
            commit('setGoods_cart_count', count)
            commit('setGoods_cart_total',total.toFixed(2))
        })
    }
  },

  modules: {

   //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里

  }

})



// WEBPACK FOOTER //
// ./src/store/store.js